import React from "react";

/**
 * Collects all the props necessary to make non-button components clickable and
 * interactable with keyboard navigation. Spread return over the element you
 * want clickable.
 * @param {() => void} callback
 * @param {boolean} isPressed
 * @param {string[]} actionKeys
 */
export function useAccessibleButtonComponent(
  callback: () => void,
  isPressed: boolean,
  actionKeys = [" ", "Enter"],
) {
  const keyboardCallback = React.useCallback(
    (evt: React.KeyboardEvent) => {
      if (actionKeys.includes(evt.key)) {
        evt.preventDefault();
        callback();
      }
    },
    [callback, actionKeys],
  );
  return React.useMemo(
    () => ({
      onClick: callback,
      onKeyDown: keyboardCallback,
      tabIndex: 0,
      style: { cursor: "pointer" },
      role: "button",
      "aria-pressed": isPressed,
    }),
    [callback, actionKeys, keyboardCallback],
  );
}
